import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { getCardById } from '../../use';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class StartCardTitleEditing extends Action<StorymapState> {
    public static ACTION_TYPE = 'StartCardTitleEditing';

    public constructor(public id: string) {
        super(StartCardTitleEditing.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: StartCardTitleEditing): void => {
    const card = getCardById(action.id);

    if (card) {
        card.isTitleEditing = true;
    }
};

//@ts-ignore
registerReducer(StartCardTitleEditing.ACTION_TYPE, reducer);
